<template>

  <div :class="classes">
    <span v-if="translation" v-html="formatTranslation()"/>
    <span v-else :class="hasDanger && expiring ? 'text-red' : 'text-neutral-900'" v-text="formatTime()"/>
  </div>

</template>
<script lang="ts" setup>
import { useWindowFocus } from '@vueuse/core'
import {useCheckoutStore} from "~/store/checkout"
import dayjs, {Dayjs} from "dayjs"

const {t} = useI18n()
const emit = defineEmits(['ended'])
const checkout = useCheckoutStore()
const focused = useWindowFocus()

const props = defineProps({
  classes: String,
  translation: String,
  limit: Dayjs,
  start: Dayjs,
  hasDanger: {
    type: Boolean,
    default: true
  },
})

const now = dayjs.utc()
const seconds = ref(0)
const limit = ref(props.limit ?? now)
const intervalId = ref<NodeJS.Timeout>()
let expiring = false

onMounted(() => {
  restartTimer()
})

function restartTimer() {
  const now = dayjs.utc()
  const start = ref(props.start ?? now)

  if (!props.limit && checkout.pi.expires_at) {
    limit.value = dayjs.utc(checkout.pi.expires_at)
  }

  seconds.value = getSecondsDifference(start.value, limit.value)
  intervalId.value = setInterval(startTime, 1000)
}

watch(focused, (isFocused) => {
  if (isFocused) {
    clearInterval(intervalId.value)
    restartTimer()
  }
})

function startTime() {
  if (seconds.value > 0) {
    if(seconds.value < 180) expiring = true
    seconds.value--
  } else {
    stopTimer()
  }
}

function stopTimer() {
  clearInterval(intervalId.value)
  emit('ended')
}

function getSecondsDifference(
      date1: any,
      date2: any
  ): number {
    const differenceInMilliseconds = date2 - date1

    if (differenceInMilliseconds <= 0) return 0

    return Math.floor(differenceInMilliseconds / 1000)
}

function formatTime(): string {
  const hours = Math.floor(seconds.value / 3600);
  const minutes = Math.floor((seconds.value % 3600) / 60);
  const remainingSeconds = seconds.value % 60;

  return `${hours > 0 ? (hours+':') : ''}${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
}

function formatTranslation(): string {
  if (!props.translation) return ''

  const html = `<span class="">${formatTime()}</span>`

  return t(props.translation, {timer: html})
}


</script>
